import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';

export const getFindSatisfactionSurveySettingsKey = (): UseDataQuery['queryKey'] => [
  'satisfaction-survey-settings',
];
